export enum ReviewTab {
  Reviews = 'reviews',
  Questions = 'questions'
}

export interface TabItem {
  id: ReviewTab;
  title: string | React.ReactNode;
  count: number;
  emptyTitle: string | React.ReactNode;
}
